import { FC } from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { VaultLogo } from 'src/components/foundations';
import useMediaQuery from 'src/hooks/useMediaQuery';
import * as Types from '../../../types';
import { hasPublicAccess } from '../../pages/Router/PublicRouting/PublicRouting';
import {
  FullWidthContainer,
  Header,
  HeaderContainer,
  HeaderLogo,
  HeaderTitle,
  SubHeader,
} from './CustomHeader.styles';

interface OwnProps {
  organisation?: string;
  currentUser?: Types.User | null;
  hideMenusWhenSmall?: boolean;
  hideID?: boolean;
  subHeader?: string;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

export const CustomHeader: FC<Props> = (props) => {
  const { t } = useTranslation();
  const isMobile = !useMediaQuery(`(min-width: 480px)`);

  const loggedInPublicUser =
    props.currentUser !== undefined &&
    props.currentUser !== null &&
    hasPublicAccess(props.currentUser);

  return (
    <FullWidthContainer isHidden={props.hideMenusWhenSmall}>
      <Header>
        {props.organisation && (
          <HeaderContainer variant={Types.NavbarVariantEnum.PUBLIC}>
            <HeaderLogo
              src={props.logo}
              alt={t('public.CustomHeader.companyLogo', {
                company: props.organisation,
              })}
              data-testid={'opr-header-link'}
            />
            <HeaderTitle>{t('public.CustomHeader.openReporting')}</HeaderTitle>
          </HeaderContainer>
        )}
        {!props.organisation && (
          <HeaderContainer variant={Types.NavbarVariantEnum.PUBLIC}>
            <VaultLogo
              size={isMobile ? 'default' : 'large'}
              color="N800"
              altText={t('public.CustomHeader.companyLogo', {
                company: 'Vault Platform',
              })}
              data-testid={'opr-header-link'}
            />
            <HeaderTitle>{t('public.CustomHeader.openReporting')}</HeaderTitle>
          </HeaderContainer>
        )}
      </Header>

      {loggedInPublicUser && !props.hideID && (
        <SubHeader>{`VAULT ID: ${props.vaultID}`}</SubHeader>
      )}
      {props.subHeader && <SubHeader>{props.subHeader}</SubHeader>}
    </FullWidthContainer>
  );
};

const mapStateToProps = (state: Types.State) => ({
  vaultID:
    state?.openReporting?.openReportingReducer?.publicReporterAccount?.username.toUpperCase() ??
    '',
  logo: state?.openReporting?.openReportReducer?.logo,
});

export default connect(mapStateToProps)(CustomHeader);
